import axios from "axios";
import API_BASE from "@/constants/ApiBase";
import API_TOKEN from "@/constants/ApiToken";
import toast from "@/plugins/toast";
import {navigateToPortalLogin} from "@/helpers/portal";
import PORTAL_BASE from "@/constants/PortalBase";

axios.defaults.baseURL = API_BASE;

axios.interceptors.request.use((config) => {
    if (!config.url.includes("/async/veiculos") && !config.url.includes("/async/filtros") && API_TOKEN) {
        config.headers.token = API_TOKEN;
        return config;
    }

    config.withCredentials = true;
    return config;
});

axios.interceptors.response.use(
    function (response) {
        const showToastError =
            response.data.statusCode &&
            response.data.statusCode === 400 &&
            response.data.payload &&
            response.data.payload.message;

        if (showToastError) {
            toast.error(response.data.payload.message.join("<br />"));
        }

        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            navigateToPortalLogin();
        }
        if(error.response.status === 403){
            document.location.href = `${PORTAL_BASE}/pagamento?desativar_novos_filtros=1`
        }
        return Promise.reject(error);
    }
);